export type JobLocation = { kind: string; latitude?: number | null; longitude?: number | null; description?: string | null };
export function locationLabel(project: { addressLine1?: unknown; location?: unknown }): string {
  const location = project.location as JobLocation | undefined;
  if (location?.kind === 'COORDINATES') return `Latitude ${location.latitude}, longitude ${location.longitude}`;
  if (location?.kind === 'DESCRIPTION') return location.description || 'Site description not entered';
  if (location?.kind === 'UNKNOWN') return 'Location needs research';
  return String(project.addressLine1 || 'Street address not entered');
}
